<template>
  <div>
    <v-list dense>
      <v-list-item>
        <v-list-item-avatar
          v-if="currentUser.avatar && currentUser.avatar.url != null"
        >
          <img class="p-accountIcon__img" :src="currentUser.avatar.url" />
        </v-list-item-avatar>
        <v-list-item-avatar v-else>
          <v-icon class="p-accountIcon__img" color="grey"> mdi-account </v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ currentUser.name }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-form
      ref="commentForm"
      class="px-4 comment-form"
      lazy-validation
      @submit.prevent="onSubmit"
      @submit="requestCommentAction"
    >
      <v-textarea
        v-model="contentText"
        outlined
        auto-grow
        :rules="contentRules"
        label="コメントを入力してください"
        class="body-2 label-size"
        rows="3"
      ></v-textarea>
    </v-form>
    <v-card-actions class="button">
      <v-spacer></v-spacer>
      <v-btn
        v-if="isPostMethod() && !hasComments()"
        text
        @click.stop="cancelAction"
      >
        キャンセル
      </v-btn>
      <v-btn text color="primary" @click="requestCommentAction">
        コメントする
      </v-btn>
    </v-card-actions>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    method: {
      type: String,
      required: true,
      validator (value) {
        return ['post'].includes(value.toLowerCase())
      }
    },
    content: {
      type: String,
      default: ''
    }
  },
  data: function () {
    return {
      contentText: this.content,
      contentRules: [(value) => !!value || 'コメントを入力してください']
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.UserStore.currentUser,
      selectedCommentItem: (state) => state.PostEditor.selectedCommentItem
    })
  },
  methods: {
    requestCommentAction () {
      if (!this.$refs.commentForm.validate()) return false

      if (this.isPostMethod()) this.postComment(this.resetForm)
    },
    postComment (callback) {
      this.$store.dispatch('PostEditor/postItemComment', {
        item: this.item,
        content: this.contentText,
        callback: callback
      })
    },
    resetForm () {
      this.$refs.commentForm.reset()
    },
    cancelAction () {
      this.$store.commit('PostEditor/SET_SELECTED_COMMENT_ITEM', null)
    },
    hasComments () {
      return !!this.item.itemComments && this.item.itemComments.length !== 0
    },
    isPostMethod () {
      return this.method === 'post'
    }
  }
}
</script>

<style scoped lang="sass">
.p-accountIcon
  vertical-align: middle
  &__img
    display: block
    border: 2px solid #D3D3D3
    border-radius: 50%
    height: 40px
    width: 40px
</style>

<style lang="sass">
.label-size label
  font-size: 0.8rem

.comment-form .v-text-field
  &__details
    display: none
</style>
